/* Product page behaviour shared by both worlds (pdp-2026-10-13).
   Lightbox with pinch and double tap zoom, delivery window, and the clothing
   page's swatch picker, made-to-measure form, sticky bar and in-page add to cart.
   Every block is a no-op when its markup is absent. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- lightbox ---------- */
  function zoom() {
    if (!document.querySelector('[data-zoom]')) return;
    var lb = document.createElement('div');
    lb.className = 'zlb'; lb.hidden = true;
    lb.innerHTML = '<button class="zlb__x" type="button" aria-label="Close">&times;</button><div class="zlb__v"><img alt=""></div><p class="zlb__hint">Pinch or double tap to zoom. Drag to move.</p>';
    document.body.appendChild(lb);
    var img = lb.querySelector('img'), view = lb.querySelector('.zlb__v');
    var scale = 1, tx = 0, ty = 0, ptrs = {}, start = null, lastTap = 0, moved = false;
    function apply() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; view.classList.toggle('is-zoomed', scale > 1.02); }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }
    function open(src) { img.src = src; reset(); lb.hidden = false; document.body.classList.add('zlb-open'); }
    function close() { lb.hidden = true; document.body.classList.remove('zlb-open'); img.removeAttribute('src'); }
    function toggleAt(x, y) {
      if (scale > 1.02) { reset(); return; }
      scale = 2.5; tx = (view.clientWidth / 2 - x) * 1.5; ty = (view.clientHeight / 2 - y) * 1.5; apply();
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-zoom]');
      if (t) { e.preventDefault(); open(t.getAttribute('data-zoom')); return; }
      if (e.target.closest('.zlb__x')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
    view.addEventListener('pointerdown', function (e) {
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY }; moved = false;
      try { view.setPointerCapture(e.pointerId); } catch (err) {}
      var k = Object.keys(ptrs);
      if (k.length === 1) start = { x: e.clientX - tx, y: e.clientY - ty };
      else if (k.length === 2) { var a = ptrs[k[0]], b = ptrs[k[1]]; start = { d: dist(a, b), s: scale }; }
    });
    view.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var k = Object.keys(ptrs);
      if (k.length === 1 && start && start.x !== undefined) {
        var nx = e.clientX - start.x, ny = e.clientY - start.y;
        if (Math.abs(nx - tx) > 3 || Math.abs(ny - ty) > 3) moved = true;
        if (scale > 1.02) { tx = nx; ty = ny; apply(); }
      } else if (k.length === 2 && start && start.d) {
        var a = ptrs[k[0]], b = ptrs[k[1]];
        scale = Math.min(5, Math.max(1, start.s * dist(a, b) / start.d)); moved = true; apply();
      }
    });
    function up(e) {
      var wasTouch = e.pointerType === 'touch';
      delete ptrs[e.pointerId]; start = null;
      if (scale < 1.02) reset();
      if (wasTouch && !moved) {
        var now = Date.now();
        if (now - lastTap < 320) { toggleAt(e.clientX, e.clientY); lastTap = 0; } else lastTap = now;
      }
    }
    view.addEventListener('pointerup', up); view.addEventListener('pointercancel', up);
    view.addEventListener('dblclick', function (e) { e.preventDefault(); toggleAt(e.clientX, e.clientY); });
    view.addEventListener('wheel', function (e) {
      e.preventDefault();
      scale = Math.min(5, Math.max(1, scale * (e.deltaY < 0 ? 1.12 : 0.9)));
      if (scale < 1.02) { tx = 0; ty = 0; }
      apply();
    }, { passive: false });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
  }

  /* ---------- delivery window ---------- */
  function eta() {
    var els = document.querySelectorAll('[data-eta]');
    if (!els.length || !window.Intl) return;
    function add(n) {
      /* calendar days, owner 2026-10-13: the window is 15 to 20 days all in */
      var d = new Date(); d.setDate(d.getDate() + n); return d;
    }
    var f = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' });
    Array.prototype.forEach.call(els, function (el) {
      var mn = parseInt(el.getAttribute('data-eta-min'), 10) || 0, mx = parseInt(el.getAttribute('data-eta-max'), 10) || 0;
      if (!mx) return;
      var t = el.getAttribute('data-eta-text') || 'Order today and it arrives between {min} and {max}.';
      el.textContent = t.replace('{min}', f.format(add(mn))).replace('{max}', f.format(add(mx)));
      el.hidden = false;
    });
  }

  /* ---------- clothing: swatches and size buttons drive the hidden selects ---------- */
  function picker() {
    var root = document.querySelector('[data-pd-product]');
    if (!root) return;
    root.addEventListener('change', function (e) {
      var r = e.target.closest('[data-pd-radio]');
      if (r) {
        var fs = r.closest('[data-pd-opt]'), sel = fs && fs.querySelector('[data-pd-option]');
        if (sel && sel.value !== r.value) { sel.value = r.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        var lbl = fs && fs.querySelector('[data-pd-sel]'); if (lbl) lbl.textContent = r.value;
        return;
      }
      var s = e.target.closest('[data-pd-option]');
      if (s) {
        var f2 = s.closest('[data-pd-opt]'), l2 = f2 && f2.querySelector('[data-pd-sel]');
        if (l2) l2.textContent = s.value;
        var sp = document.querySelector('[data-pd-sticky-price]'), pe = root.querySelector('[data-pd-price]');
        if (sp && pe) setTimeout(function () { sp.innerHTML = pe.innerHTML; }, 0);
      }
    });
  }

  /* ---------- clothing: made to measure ---------- */
  function mtm() {
    var box = document.querySelector('[data-mtm]');
    if (!box) return;
    var t = box.querySelector('[data-mtm-toggle]'), f = box.querySelector('.mtm__form');
    function set(on) {
      f.hidden = !on;
      Array.prototype.forEach.call(f.querySelectorAll('input,select,textarea'), function (i) { i.disabled = !on; });
      box.classList.toggle('is-on', on);
    }
    t.addEventListener('change', function () { set(t.checked); if (t.checked) { var first = f.querySelector('input'); if (first) first.focus(); } });
    set(t.checked);
  }

  /* ---------- clothing: sticky bar on phones ---------- */
  function sticky() {
    var bar = document.querySelector('[data-pd-sticky]'), btn = document.querySelector('[data-pd-add]');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var vis = true;
    function paint() { var show = !vis && window.innerWidth < 900; bar.hidden = !show; document.body.classList.toggle('has-pd-sticky', show); }
    new IntersectionObserver(function (en) { vis = en[0].isIntersecting; paint(); }, { rootMargin: '0px 0px -10px 0px' }).observe(btn);
    window.addEventListener('resize', paint);
  }

  /* ---------- clothing: add to cart without leaving the page ---------- */
  function addToCart() {
    var form = document.getElementById('pd-form');
    if (!form || !window.fetch || !window.FormData) return;
    var toast = document.querySelector('[data-pd-toast]');
    var busy = false;
    var routes = (window.PD && window.PD.routes) || {};
    form.addEventListener('submit', function (e) {
      var mt = document.querySelector('[data-mtm-toggle]');
      if (mt && mt.checked) {
        var miss = Array.prototype.filter.call(document.querySelectorAll('[data-mtm-req]'), function (i) { return !i.value.trim(); });
        if (miss.length) {
          e.preventDefault(); miss[0].focus();
          if (miss[0].setCustomValidity) { miss[0].setCustomValidity('Please add this measurement'); miss[0].reportValidity(); miss[0].setCustomValidity(''); }
          return;
        }
      }
      if (busy) { e.preventDefault(); return; }
      e.preventDefault(); busy = true;
      var btn = form.querySelector('[data-pd-add]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding'; btn.disabled = true; }
      var fd = new FormData(form);
      fetch((routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to cart');
          return fetch((routes.cart || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            var a = document.querySelector('.icons a[aria-label="Cart"]');
            if (a) { var n = a.querySelector('.icons__n'); if (!n) { n = document.createElement('span'); n.className = 'icons__n'; a.appendChild(n); } n.textContent = cart.item_count; }
            if (toast) {
              var it = toast.querySelector('[data-pd-toast-item]');
              if (it) it.textContent = res.j.product_title + (res.j.variant_title ? ', ' + res.j.variant_title : '');
              toast.hidden = false;
            }
            if (btn) btn.textContent = 'Added';
          });
        })
        .catch(function (err) { if (btn) btn.textContent = err.message || 'Could not add to cart'; })
        .then(function () {
          setTimeout(function () { if (btn) { btn.textContent = label; btn.disabled = false; } busy = false; }, 1800);
        });
    });
    document.addEventListener('click', function (e) { if (toast && e.target.closest('[data-pd-toast-close]')) toast.hidden = true; });
    document.addEventListener('keydown', function (e) { if (toast && e.key === 'Escape') toast.hidden = true; });
  }

  ready(function () { zoom(); eta(); picker(); mtm(); sticky(); addToCart(); });
})();
